import { Component } from '@angular/core';
import { defaultConfig } from 'src/app/app.general';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent {
  applicationName = defaultConfig.applicationName;
  companyName = defaultConfig.companyName;
  privatePolicy = defaultConfig.privatePolicy;
}
